interface ProgressBarProps {
  /** 0-100 for determinate, undefined for indeterminate */
  value?: number;
  color?: string;
  className?: string;
}

export function ProgressBar({
  value,
  color = "bg-brand-purple",
  className = "",
}: ProgressBarProps) {
  const isDeterminate = value !== undefined;

  return (
    <div className={`h-0.5 w-full bg-surface-lighter/30 rounded-full overflow-hidden ${className}`}>
      {isDeterminate ? (
        <div
          className={`h-full ${color} rounded-full transition-[width] duration-500 ease-out`}
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      ) : (
        <div className={`h-full w-1/4 ${color} rounded-full progress-indeterminate`} />
      )}
    </div>
  );
}
